import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { TrialAccountRequestFilterType } from '../../state/models';

interface FilterOption {
  id: TrialAccountRequestFilterType;
  name: string;
  enabled: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'app-trial-accounts-filters',
  templateUrl: './trial-accounts-filters.component.html',
  styleUrls: ['./trial-accounts-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrialAccountsFiltersComponent implements OnChanges {
  @Input() filters: TrialAccountRequestFilterType[] | undefined;
  @Output() changeFilters = new EventEmitter<TrialAccountRequestFilterType[]>();

  public filtersOptions: FilterOption[] = [
    {
      id: TrialAccountRequestFilterType.Approved,
      name: 'Approved',
      enabled: false,
    },
    {
      id: TrialAccountRequestFilterType.Declined,
      name: 'Declined',
      enabled: false,
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    const filters = changes['filters'];
    if (filters?.currentValue) {
      this.initFilters(filters?.currentValue);
    }
  }

  public change(id: TrialAccountRequestFilterType, enabled: boolean) {
    this.changeFilters.emit(this.updateFilters(id, enabled));
  }

  public trackByFilters(_: number, { id }: FilterOption) {
    return id;
  }

  private updateFilters(id: TrialAccountRequestFilterType, enabled: boolean) {
    this.filtersOptions = this.filtersOptions.map((f) =>
      f.id === id ? { ...f, enabled } : f,
    );
    return this.filtersOptions.filter((f) => !!f.enabled).map((f) => f.id);
  }

  private initFilters(filters: TrialAccountRequestFilterType[]) {
    const filtersLookup = (filters || []).reduce((a, b) => {
      a[b] = true;
      return a;
    }, {});
    this.filtersOptions = this.filtersOptions.map((filter) => ({
      ...filter,
      enabled: filtersLookup[filter.id] as boolean,
    }));
  }
}
